<template>
  <div class="game-container" :style="getStyle(startGameConfig)">
    <div class="content">
      <img
        v-for="(img, i) in images"
        :key="'image1_' + i"
        :class="['mySlides', { opaque: isOpen(i) }, { active: isOpen(i) }]"
        :src="img.src"
        :style="getStyle(img)"
      />
      <div class="panel">
        <div class="left hover-text-khaki" @click="nextSlide(-1)">&#10094;</div>
        <div class="right hover-text-khaki" @click="nextSlide(1)">&#10095;</div>
        <span
          v-for="(img, i) in images"
          :key="'image2_' + i"
          :class="['badge border transparent hover-khaki', { khaki: isOpen(i) }]"
          @click="toggleSlide(i)"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import defaultMixins from '../../mixins/defaultMixin';
export default {
  name: 'mp-gallery-fade',
  mixins: [defaultMixins],
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      images: [],
      slideInx: 0,
    };
  },
  beforeMount() {
    this.newGame();
  },
  mounted() {},
  methods: {
    newGame() {
      this.initData = this.startGameConfig;
      let items = Object.assign({}, this.initData.items);
      var i = -1;
      var self = this;
      this.images = _.map(items, (item) => {
        i++;
        return {
          w: self.startGameConfig.width,
          txt: item.txt,
          src: item.src,
          style: self.startGameConfig.style,
          cssStyle: item.cssStyle,
          isOpen: false,
          id: 'img-' + i,
        };
      });
      this.images[0].isOpen = true;
      this.slideInx = 0;
    },
    isOpen(i) {
      return this.images[i].isOpen;
    },
    nextSlide(n) {
      this.toggleSlide((this.slideInx += n));
    },
    toggleSlide(n) {
      this.slideInx = n;
      if (this.slideInx >= this.images.length) {
        this.slideInx = 0;
      }
      if (this.slideInx < 0) {
        this.slideInx = this.images.length - 1;
      }
      this.images.forEach(function(img) {
        img.isOpen = false;
      });
      this.images[this.slideInx].isOpen = true;
    },
    resetGameAction() {
      this.newGame();
    },
    getStyle(item) {
      // padding: 5%;
      // margin-top: 12%;
      return _.merge({}, this.getCustomStyle(item));
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function(value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding-top: 80px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.hover-none:hover,
.transparent {
  background-color: transparent !important;
}

.content {
  margin: auto;
  font-size: 46px !important;
  text-align: center !important;
  color: #black !important;
  line-height: 1.5;
  display: block;
}

.mySlides {
  display: none;
  opacity: 0;
  vertical-align: middle;
  border-style: none;
  box-shadow: 5px 5px 5px #aaa;

  transition: opacity 0.3s ease-in-out;

  &.active {
    display: block;
    opacity: 1;

    &.opaque {
      animation: anim 0.3s ease-in-out;
    }
  }
}

.badge,
.left,
.right {
  cursor: pointer;
}

.left {
  float: left !important;
}
.right {
  float: right !important;
}

.hover-text-khaki:hover,
.text-khaki {
  color: #b4aa50 !important;
}

.hover-khaki:hover,
.khaki {
  color: #000 !important;
  background-color: #b4aa50 !important;
}

.hover-white:hover,
.white {
  color: #000 !important;
  background-color: #fff !important;
}

.border {
  border: 1px solid #ccc !important;
}

.badge {
  height: 32px;
  width: 32px;
  padding: 0;
  margin-right: 10px;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
}

.panel {
  width: 100%;
  color: #black;
  margin-top: 16px !important;
  margin-bottom: 16px !important;
  text-align: center !important;
  padding: 0.01em 16px;
  position: relative;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 0%);
}

@keyframes anim {
  0% {
    display: none;
    opacity: 0;
  }
  1% {
    display: block;
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

*,
::after,
::before {
  box-sizing: inherit;
}
</style>
